import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { startLeadQueueSync } from "./lib/leadSubmit";

startLeadQueueSync();

createRoot(document.getElementById("root")!).render(<App />);
